import { compact, concat, isEmpty, join } from 'lodash/fp';

import { UnicodeEntity } from '@mews/enums';
import { Address } from '../../modules/entities/enterprises/types';

export const getAddressString = (address: Address) => {
    if (address == null) {
        return '';
    }

    const { line1, line2, postalCode, city } = address;
    const parts = compact([line1, line2]);
    const subpart = compact([postalCode, city]);

    if (isEmpty(subpart)) {
        return join(`${UnicodeEntity.Comma} `, parts);
    }

    const partsWithSubpart = concat(parts, join(' ', subpart));
    return join(`${UnicodeEntity.Comma} `, partsWithSubpart);
};
